export default {
  loadingProfile: "Caricamento profilo...",
  errorLoadingProfile: "Errore nel caricamento del profilo",
  profileChangedTo: "Profilo impostato su {{type}}",
  sectionSaved: "Sezione salvata con successo",
  saveSection: "Salva sezione",
  revertSection: "Annulla",
  checkHighlighted: "Controlla i campi evidenziati",
  pageTitle: "Impostazioni",
  sectionsNav: "Sezioni",
  profileDescription: "Gestisci profilo, contatti e dati di pagamento",
  confirmChangeTitle: "Cambiare il tipo di profilo?",
  confirmChangeMessage:
    "Passando da «{{from}}» a «{{to}}» verranno cancellati i campi specifici del profilo {{dataType}} (nome, date di nascita o dati societari). Indirizzo, contatti, documento e pagamento restano salvati.",
  individual: "Persona fisica",
  company: "Azienda",
  confirmChange: "Sì, cambia tipo",
  adminPageTitle: "Impostazioni",
  adminPageDescription: "Gestisci il tuo account",
  adminCardTitle: "Profilo staff",
  adminBadge: "Staff",
  taxValidation: {
    vatNotFound: "Partita IVA non trovata nel registro.",
    vatMatched: "{{name}} · {{address}}",
    fiscalCodeInvalid: "Codice fiscale non valido.",
  },
  forms: {
    region: {
      cardTitle: "Regione di pagamento",
      hint: "Assegnata alla creazione dell'account e non modificabile.",
    },
    profileType: {
      cardTitle: "Tipo di profilo",
      individualTitle: "Persona fisica",
      individualDesc: "Cittadino privato",
      businessTitle: "Azienda",
      businessDesc: "Società o organizzazione",
    },
    profileStatus: {
      completeTitle: "Profilo completo",
      incompleteTitle: "Profilo incompleto",
      incompleteDesc:
        "Completa tutti i campi obbligatori per attivare il tuo account",
    },
    person: {
      cardPersonal: "Dati personali",
      firstName: "Nome",
      lastName: "Cognome",
      birthDate: "Data di nascita",
      birthPlace: "Luogo di nascita",
      birthPlacePh: "Città, Paese",
      idAsShown: "Come sul documento",
      fiscalCode: "Codice fiscale / ID fiscale",
      fiscalCodePh: "Il tuo codice di identificazione fiscale",
      cardResidence: "Domicilio",
      cardIdentity: "Documento d’identità",
    },
    company: {
      cardBusiness: "Dati aziendali",
      companyName: "Ragione sociale",
      companyNamePh: "Acme S.r.l.",
      vatNumber: "Partita IVA",
      vatNumberPh: "XX12345678901",
      taxId: "Codice fiscale azienda",
      taxIdPh: "Codice di identificazione fiscale della società",
      cardRegistered: "Sede legale",
      cardLegalRep: "Rappresentante legale",
      fullName: "Nome e cognome",
      fullNamePh: "Mario Rossi",
    },
    address: {
      street: "Indirizzo",
      streetPh: "Via Roma 1",
      postalCode: "CAP",
      postalPh: "20100",
      city: "Città",
      cityPh: "Milano",
      state: "Provincia / stato",
      statePh: "MI",
      country: "Paese",
      countryPh: "Italia",
    },
    document: {
      type: "Tipo di documento",
      typePh: "Carta d’identità, passaporto...",
      number: "Numero",
      numberPh: "AB1234567",
      issuer: "Ente rilascio",
      issuerPh: "Comune, questura...",
      issueDate: "Data di rilascio",
      expiryDate: "Data di scadenza",
    },
    contact: {
      cardTitle: "Contatti",
      phone: "Numero di telefono",
      phonePlaceholder: "+34 612 345 678",
      phoneHint:
        "Digita il prefisso internazionale (es. +34) o scegli un paese; la bandiera si aggiorna automaticamente.",
      email: "Email",
      emailPh: "email@esempio.com",
      emailHint:
        "Dopo il salvataggio, verifica con il link che ti inviamo via email — non serve un codice.",
      pec: "PEC",
      pecPh: "nome@pec.it",
      pecHint: "Per la fatturazione elettronica",
      verified: "Verificato",
      resendCode: "Reinvia codice",
      resendLink: "Reinvia link",
      verifySaveFirst: "Salva le modifiche, poi verifica.",
      confirmCode: "Conferma",
      sendSmsCode: "Invia codice SMS",
      sendEmailLink: "Invia email di verifica",
      enterSmsCode: "Inserisci il codice a 6 cifre che ti abbiamo inviato via SMS.",
      otpAriaLabel: "Codice di verifica SMS",
      verifyPhoneSent: "SMS inviato — inserisci il codice qui sotto.",
      verifyEmailSent:
        "Ti abbiamo inviato un link di verifica. Apri la email e cliccalo (anche dal telefono) — non serve un codice. Questa pagina si aggiorna da sola.",
      verifyEmailWaiting:
        "In attesa che tu clicchi il link nella email…",
      verifyPhoneSuccess: "Telefono verificato.",
      verifyEmailSuccess: "Email verificata.",
      verifyPhoneLimit: "Limite SMS raggiunto. Riprova più tardi.",
      verifyEmailLimit: "Limite email raggiunto. Riprova più tardi.",
      verifyConfirmLimit: "Troppi tentativi. Riprova più tardi.",
      verifyPhoneNotSmsCapable: "Questo numero non può ricevere SMS.",
      verifyCodeInvalid: "Codice non valido o scaduto.",
      notificationChannel: "Notifiche prenotazioni",
      notificationChannelHint:
        "Scegli dove ricevere avvisi su nuove prenotazioni, messaggi e cancellazioni.",
      notificationChannelWhatsApp: "WhatsApp",
      notificationChannelEmail: "Email",
      notificationLanguage: "Lingua notifiche",
    },
    payment: {
      cardTitle: "Dati di pagamento",
      iban: "IBAN",
      ibanOptional: "IBAN",
      ibanPh: "XX00 0000 0000 0000 0000 00",
      ibanHint: "15-34 caratteri",
      accountHolder: "Intestatario conto",
      accountHolderOptional: "Intestatario conto",
      accountHolderPh: "Mario Rossi o Acme S.r.l.",
      accountHolderHint: "Almeno 3 caratteri",
    },
  },
} as const;
